import React, {useCallback, useEffect, useState} from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {registration, registrationFailure} from "../../store/main/action";



// один ключ на весь флоу: сюда пишет и страница регистрации, и переход по ссылке
export const REFERRAL_STORAGE_KEY = 'tc-referral-code';

const RegMain = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formErr = useSelector(store => store.main.registrationErr);
    const authStatus = useSelector(store => store.main.authorizationStatus);

    // код из ссылки /sign-up/:referralCode; если пришли без него — берём
    // сохранённый с прошлого перехода по реферальной ссылке
    const { referralCode } = useParams();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password_confirmation, setPassword_confirmation] = useState('');
    const [referral_code, setReferral_code] = useState(referralCode || localStorage.getItem(REFERRAL_STORAGE_KEY) || '');

    useEffect(()=>{
        if (!referralCode){
            return;
        }
        // код переживает уход со страницы: пользователь может сначала
        // почитать лендинг и вернуться к регистрации уже без него в адресе
        localStorage.setItem(REFERRAL_STORAGE_KEY, referralCode);
        setReferral_code(referralCode);
    },[referralCode])

    const sendFormHandler = useCallback(() => {
        const inviteId = localStorage.getItem('inviteId');

        const payload = {
            email,
            password,
            password_confirmation,
        };

        if (inviteId) {
            payload.invite_code = inviteId;
        }

        if (referral_code.trim().length) {
            // POST /register ждёт именно referral_code — под ключом code
            // сервер кода не видел и в структуру пригласителя не ставил
            payload.referral_code = referral_code.trim();
        }

        dispatch(registration(payload));
    }, [dispatch, email, password, password_confirmation, referral_code]);

    useEffect(()=>{
        if (authStatus){
            localStorage.removeItem(REFERRAL_STORAGE_KEY);
            navigate('/cabinet');
        }
    },[authStatus, navigate])

    useEffect(() => {
        const onKeyDown = e => {
            if(e.keyCode === 13) {
                sendFormHandler();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.formWrap}`}>
                    <div className={`${Styles.formTitle}`}>{t('Регистрация')}</div>
                    <div className={`${Styles.contentBox}`}>
                        <div className={`${Styles.inputWrap} ${formErr?.email ? Styles.inputWrapWithErr : null}`}>
                            <div className={`${Styles.inputTitle}`}>{t('Почта')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="text"
                                placeholder="example@gmail.com"
                                value={email}
                                onChange={(e)=>{setEmail(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.email){
                                        delete formErr.email;
                                        dispatch(registrationFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.email ? Styles.tcErrActive : null}`}>{formErr?.email ? formErr.email : null}</div>
                        </div>
                        <div className={`${Styles.inputWrap} ${formErr?.password ? Styles.inputWrapWithErr : null}`}>
                            <div className={`${Styles.inputTitle}`}>{t('Пароль')}</div>
                            <input className={`${Styles.tcInput}`}
                                   type="password"
                                   placeholder="••••••••"
                                   value={password}
                                   onChange={(e)=>{setPassword(e.target.value)}}
                                   onKeyDown={(event)=>{
                                       if (formErr.password){
                                           delete formErr.password;
                                           dispatch(registrationFailure(formErr));
                                       }
                                   }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.password?.[0] ? Styles.tcErrActive : null}`}>{formErr?.password?.[0] ? formErr.password[0] : null}</div>
                        </div>
                        <div className={`${Styles.inputWrap} ${formErr?.password_confirmation ? Styles.inputWrapWithErr : null}`}>
                            <div className={`${Styles.inputTitle}`}>{t('Подтвердите пароль')}</div>
                            <input className={`${Styles.tcInput}`}
                                   type="password"
                                   placeholder="••••••••"
                                   value={password_confirmation}
                                   onChange={(e)=>{setPassword_confirmation(e.target.value)}}
                                   onKeyDown={(event)=>{
                                       if (formErr.password_confirmation){
                                           delete formErr.password_confirmation;
                                           dispatch(registrationFailure(formErr));
                                       }
                                   }}
                            />
                            <div className={`${Styles.tcErr}`}/>
                        </div>
                        <div className={`${Styles.inputWrap} ${formErr?.referral_code ? Styles.inputWrapWithErr : null}`}>
                            <div className={`${Styles.inputTitle}`}>{t('Реферальный код')} <span>({t('необязательно')})</span></div>
                            <input className={`${Styles.tcInput}`}
                                   type="text"
                                   placeholder="K7Q2M9XA"
                                   value={referral_code}
                                   onChange={(e)=>{setReferral_code(e.target.value)}}
                                   onKeyDown={(event)=>{
                                       if (formErr.referral_code){
                                           delete formErr.referral_code;
                                           dispatch(registrationFailure(formErr));
                                       }
                                   }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.referral_code ? Styles.tcErrActive : null}`}>
                                {formErr?.referral_code ? formErr.referral_code : null}
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.note}`}>{t('У вас уже есть аккаунт?')} <span onClick={()=>{navigate('/sign-in')}}>{t('Вход')}</span></div>
                    <div className={`${Styles.tcBtn}`} onClick={()=>{sendFormHandler()}}>{t('Регистрация')}</div>
                </div>
            </div>
        </section>
    );
};

export default RegMain;